import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/**
 * Mileage, engine, fuel and gearbox on one line that never wraps.
 *
 * Wrapping is what made the old grid ragged: a card whose specs took two
 * lines pushed its price and button out of step with the card beside it. One
 * fixed line is also how a buyer actually scans a grid — left to right, not
 * down.
 */
export function VehicleSpecLine({ specs }: { specs: readonly string[] }) {
  // A car with nothing recorded still occupies the row, or its card's price
  // and button would ride up past every other card in the grid.
  if (!specs.length) return <Box aria-hidden sx={{ minHeight: '1.4em' }} />;
  return (
    <Stack
      component="ul"
      direction="row"
      sx={{
        listStyle: 'none',
        p: 0,
        m: 0,
        minWidth: 0,
        overflow: 'hidden',
        color: 'text.secondary',
        '& > li + li::before': {
          content: '"·"',
          mx: 1.5,
          color: 'text.disabled',
        },
      }}
    >
      {specs.map((s) => (
        <Typography
          key={s}
          component="li"
          variant="body2"
          noWrap
          className="tabular-nums"
          sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}
        >
          {s}
        </Typography>
      ))}
    </Stack>
  );
}
